import { ProjectTemplate } from "PosterEditor/model/project-template";
import { PosterProject } from "PosterEditor/model/poster-project";
import { useTemplateStore } from "entity-store/template-store/use-template-store";
import { useGpsStore } from "entity-store/gps-store/use-gps-store";
import { useImageStore } from "entity-store/image-store/use-image-store";
import { v4 as uuid } from "uuid";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useDuplicateTemplate = () => {
  const queryClient = useQueryClient();
  const { putTemplate } = useTemplateStore();
  const { copyPublicGPSSource } = useGpsStore();
  const { duplicatePublicImage } = useImageStore();

  const duplicateTemplateMutation = useMutation({
    mutationFn: async (template: ProjectTemplate) => {
      const newTemplateID = uuid();
      const newProjectID = uuid();

      const gpsSourceID = template.project.gpsSourceIDs[0];
      let newGPSSourceID: string | undefined;

      if (gpsSourceID) {
        newGPSSourceID = await copyPublicGPSSource(gpsSourceID);
      }

      const newProject: PosterProject = {
        ...template.project,
        id: newProjectID,
        gpsSourceIDs: newGPSSourceID ? [newGPSSourceID] : [],
        createdAt: new Date(),
      };

      const newTemplate: ProjectTemplate = {
        ...template,
        id: newTemplateID,
        project: newProject,
        createdAt: new Date(),
      };

      const imageURL = await duplicatePublicImage(template.thumbnail, "png");
      if (imageURL) {
        newTemplate.thumbnail = imageURL;
      }

      await putTemplate.mutateAsync(newTemplate);
      return newTemplate;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["templates"] });
    },
  });

  return {
    duplicateTemplate: duplicateTemplateMutation,
  };
};
